import type { PowerAction } from '@pinia/node';
import { useProjectStore } from '@pinia/project';
import useCloudService from '@grpc/composables/useCloudService';
import type { PowerActionNodeResponse } from 'gpcore-grpc/gpcore/api/cloud/v1/responses_pb';
import { create } from '@bufbuild/protobuf';
import { PowerActionNodeRequestSchema } from 'gpcore-grpc/gpcore/api/cloud/v1/requests_pb';

export default () => {
  const projectStore = useProjectStore();
  const userApi = useCloudService();

  return async (action: PowerAction): Promise<PowerActionNodeResponse> => {
    const request = create(PowerActionNodeRequestSchema);
    request.id = action.node.id;
    request.projectId = action.node.id;
    request.projectId = projectStore.project.id;
    request.powerState = action.action;

    const { response, error } = await userApi.executeApiCall('powerActionNode', request);
    if (error != null) throw error;

    return response;
  };
};
